<template>
  <div>
    <section class="xs-banner service-banner contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-5 align-self-center">
            <div class="xs-banner-content">
              <ul class="breadcrumbs list-inline wow fadeInLeft" data-wow-duration="2s">
                <li><a href="https://episcloud.com">Trang chủ</a></li>
                <li>Chính sách khiếu nại</li>
              </ul>
              <p class="wow fadeInUp" data-wow-duration="1.5s"></p>
            </div><!-- .xs-banner-content END -->
          </div>
          <div class="col-lg-6 col-md-7">
            <div class="inner-welcome-image-group">
              <img src="../assets/images/about-bg.png" alt="Welcome banner image">
              <img src="../assets/images/info-1.png" class="banner-ico banner-ico-1"
                   alt="banner icon"><img src="../assets/images/board.png"
                                          class="banner-ico banner-ico-2" alt="banner icon"></div>
          </div>
        </div><!-- .row END -->
      </div><!-- .container END -->
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-603" class="full-width-content post-603 page type-page status-publish hentry">
          <div data-elementor-type="wp-post" data-elementor-id="603" class="elementor elementor-603"
               data-elementor-settings="[]">
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-9af42a3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="9af42a3" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c5674a6"
                        data-id="c5674a6" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-e00349e elementor-widget elementor-widget-xs-heading"
                              data-id="e00349e" data-element_type="widget" data-widget_type="xs-heading.default">
                              <div class="elementor-widget-container">
                                <div class="xs-heading">
                                  <h3 class="heading-sub-title">Các điều khoản của chúng tôi</h3>
                                  <h2 class="heading-title">CÁC ĐIỀU KHOẢN <span>CHÍNH SÁCH KHIẾU NẠI</span></h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-7337b23 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="7337b23" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-8cb6da2"
                        data-id="8cb6da2" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-77c09c1 elementor-widget elementor-widget-heading"
                              data-id="77c09c1" data-element_type="widget" data-widget_type="heading.default">
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">Nguyên tắc  sử dụng hệ thống EPIS Cloud</h2>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-8e22874 elementor-widget elementor-widget-text-editor"
                              data-id="8e22874" data-element_type="widget" data-widget_type="text-editor.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <p>
                                    Khách hàng đang  sử dụng dịch vụ của EPIS Cloud được bảo đảm quyền lợi hợp pháp, theo thỏa thuận trong hợp đồng và quy định của pháp luật.
                                  </p>
                                  <p>
                                    Mọi thắc mắc, khiếu nại của khách hàng liên quan đến chất lượng dịch vụ đều được tiếp nhận và giải quyết nhanh chóng, trên tinh thần cầu thị, thiện chí. Thời gian giải quyết tối đa trong vòng 10 - 20 ngày.
                                  </p>
                                    <p>
                                       – Không quá 50 ngày đối với vấn đề về chất lượng dịch vụ
                                    </p>
                                    <p>
                                       – Không quá 20 ngày đối với vấn đề kinh doanh
                                    </p>
                                  <p>
                                    Việc tiếp nhận và giải quyết khiếu nại khách hàng được ghi nhận và trả lời bằng văn bản. Tuân thủ đúng theo quy định của pháp luật hiện hành.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-920edc0 elementor-widget elementor-widget-heading"
                              data-id="920edc0" data-element_type="widget" data-widget_type="heading.default">
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">Trình tự, thủ tục giải quyết</h2></div>
                            </div>
                            <div
                              class="elementor-element elementor-element-21207c5 elementor-widget elementor-widget-text-editor"
                              data-id="21207c5" data-element_type="widget" data-widget_type="text-editor.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <p>
                                    Bước 1: Tiếp nhận phản ánh, khiếu nại
                                    Khi có thắc mắc hoặc khiếu nại về chất lượng dịch vụ, khách hàng liên hệ với EPIS Cloud  qua các hình thức sau:
                                  </p>
                                  <p>
                                    – Gửi email đến địa chỉ: account@episcloud.com
                                  </p>
                                  <p>Lưu ý:</p>
                                  <p>
                                    – Trong email  vui lòng ghi rõ nội dung phản ánh, khiếu nại, yêu cầu cần giải quyết và cung cấp các tài liệu, thông tin có liên quan đến dịch vụ và sử dụng dịch vụ.
                                  </p>
                                  <p>Bước 2: Giải quyết</p>
                                  <p>
                                    – Ngay sau khi tiếp nhận hay nhận được được email, đơn của khách hàng, EPIS Cloud  sẽ tiến hành xác minh, kiểm tra nội dung phản ánh. Và trong vòng  24h - 48h EPIS Cloud  sẽ có Thư trả lời (nếu đã khắc phục xong hoặc cần trao đổi, cung cấp thêm thông tin …)
                                  </p>
                                  <p>
                                    – Trường hợp sự việc phức tạp, liên quan đến nhiều bên hoặc cần có thời gian xác minh, khắc phục …, thời gian giải quyết sẽ dài hơn. Nhưng không quá 30 ngày.
                                  </p>
                                  <p>
                                    Bước 3: Giải quyết lần 2
                                  </p>
                                  <p>– Nếu khách hàng chưa/không đồng ý với giải quyết của EPIS Cloud , EPIS Cloud  sẽ có Thư trả lời hoặc Thư mời (lần 2) với mong muốn đạt được sự thỏa thuận giữa hai bên.</p>
                                  <p>– Nếu khách hàng vẫn không/chưa đồng ý với giải quyết lần 2 của EPIS Cloud  thì có thể gửi Đơn đến cơ quan quản lý hoặc khởi kiện ra Tòa án.</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-20eb49d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="20eb49d" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-cae3056 animated-slow animated fadeInLeft"
                        data-id="cae3056" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInLeft&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-d1299d0 elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="d1299d0" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="122" height="138"
                                           src="../assets/images/sheild-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Days money back guarantee</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-a3396ca animated-slow animated fadeInRight"
                        data-id="a3396ca" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-96fe986 elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="96fe986" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="129" height="138"
                                           src="../assets/images/cloud-lock-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Build and protect your brand</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-cfd00bf elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="cfd00bf" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-284cb37"
                        data-id="284cb37" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-896f9a6 elementor-widget elementor-widget-spacer"
                              data-id="896f9a6" data-element_type="widget" data-widget_type="spacer.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-spacer">
                                  <div class="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'Faq'
}
</script>

<style scoped>
.elementor-603 .elementor-element.elementor-element-a651412 {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  padding: 80px 10px 80px 10px;
}

.elementor-603 .elementor-element.elementor-element-a651412 > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-603 .elementor-element.elementor-element-4615f06 .elementor-toggle-item:not(:last-child) {
  margin-bottom: 17px;
}

.elementor-603 .elementor-element.elementor-element-4615f06 .elementor-tab-title {
  background-color: #F8FAFE;
  padding: 19px 30px 19px 30px;
}

.elementor-603 .elementor-element.elementor-element-4615f06 .elementor-toggle-title, .elementor-603 .elementor-element.elementor-element-4615f06 .elementor-toggle-icon {
  color: #000000;
}

.elementor-603 .elementor-element.elementor-element-4615f06 .elementor-toggle-icon svg {
  fill: #000000;
}

.elementor-603 .elementor-element.elementor-element-4615f06 .elementor-tab-content {
  background-color: #ffffff;
  color: #70799f;
  font-family: "Karla", Sans-serif;
  letter-spacing: -0.4px;
  padding: 0px 30px 30px 30px;
}

.elementor-603 .elementor-element.elementor-element-3b884f4 .elementor-toggle-item:not(:last-child) {
  margin-bottom: 17px;
}

.elementor-603 .elementor-element.elementor-element-3b884f4 .elementor-tab-title {
  background-color: #F8FAFE;
  padding: 19px 30px 19px 30px;
}

.elementor-603 .elementor-element.elementor-element-3b884f4 .elementor-toggle-title, .elementor-603 .elementor-element.elementor-element-3b884f4 .elementor-toggle-icon {
  color: #000000;
}

.elementor-603 .elementor-element.elementor-element-3b884f4 .elementor-toggle-icon svg {
  fill: #000000;
}

.elementor-603 .elementor-element.elementor-element-3b884f4 .elementor-tab-content {
  background-color: #ffffff;
  color: #70799f;
  font-family: "Karla", Sans-serif;
  letter-spacing: -0.4px;
  padding: 0px 30px 30px 30px;
}

.elementor-603 .elementor-element.elementor-element-47e2812:not(.elementor-motion-effects-element-type-background), .elementor-603 .elementor-element.elementor-element-47e2812 > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-color: #f8fafe;
}

.elementor-603 .elementor-element.elementor-element-47e2812 {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  padding: 80px 10px 80px 10px;
}

.elementor-603 .elementor-element.elementor-element-47e2812 > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-603 .elementor-element.elementor-element-d6628d5 > .elementor-container {
  min-height: 500px;
}

.elementor-603 .elementor-element.elementor-element-d6628d5 {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
}

.elementor-603 .elementor-element.elementor-element-d6628d5 > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-603 .elementor-element.elementor-element-3097b73 .xs-testimonial-slider .owl-item .xs-testimonial-item::before, .xs-testimonial-slider .owl-item .xs-testimonial-item::after, .xs-testimonial-slider .owl-item .xs-testimonial-item {
  background-color: transparent;
  background-image: linear-gradient(90deg, #15095e 0%, #1045db 100%);
}

.elementor-603 .elementor-element.elementor-element-3097b73 .xs-testimonial-slider .owl-item:not(.center) .xs-testimonial-item {
  opacity: 0.5;
}

.elementor-603 .elementor-element.elementor-element-3097b73 .commentor-bio .commentor-title {
  color: #ffffff;
}

.elementor-603 .elementor-element.elementor-element-3097b73 .xs-testimonial-slider .owl-item.center .testimonial-content .commentor-info {
  color: #ffffff;
}

.elementor-603 .elementor-element.elementor-element-3097b73 .xs-testimonial-slider .owl-item:not(.center) .xs-testimonial-item p.commentor-info {
  color: #ffffff;
}

.elementor-603 .elementor-element.elementor-element-3097b73 .testimonial-content > p {
  color: #ffffff;
}

.elementor-603 .elementor-element.elementor-element-3097b73 .xs-testimonial-slider .owl-item:not(.center) .xs-testimonial-item p {
  color: #ffffff;
}

.elementor-603 .elementor-element.elementor-element-ef98371 {
  margin-top: -100px;
  margin-bottom: 0px;
}

.elementor-603 .elementor-element.elementor-element-20eb49d {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  margin-top: 0px;
  margin-bottom: -98px;
  padding: 100px 0px 0px 0px;
  z-index: 33;
}

.elementor-603 .elementor-element.elementor-element-20eb49d > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-603 .elementor-element.elementor-element-cae3056 > .elementor-element-populated {
  padding: 0px 15px 0px 15px;
}

.elementor-603 .elementor-element.elementor-element-d1299d0 .xs-feature-group {
  background-color: #ffffff;
}

.elementor-603 .elementor-element.elementor-element-d1299d0 .xs-feature-group .xs-title {
  color: #1e1e1e;
}

.elementor-603 .elementor-element.elementor-element-d1299d0 .xs-feature-group p {
  color: #70799f;
}

.elementor-603 .elementor-element.elementor-element-d1299d0 .btn-secondary {
  color: #ffffff;
  background-color: #1868dd;
}

.elementor-603 .elementor-element.elementor-element-d1299d0 {
  z-index: 2;
}

.elementor-603 .elementor-element.elementor-element-d1299d0 > .elementor-widget-container {
  box-shadow: 0px -10px 25px 0px rgba(0, 0, 0, 0.04);
}

.elementor-603 .elementor-element.elementor-element-a3396ca > .elementor-element-populated {
  padding: 0px 15px 0px 15px;
}

.elementor-603 .elementor-element.elementor-element-96fe986 .xs-feature-group {
  background-color: #ffffff;
}

.elementor-603 .elementor-element.elementor-element-96fe986 .xs-feature-group .xs-title {
  color: #1e1e1e;
}

.elementor-603 .elementor-element.elementor-element-96fe986 .xs-feature-group p {
  color: #70799f;
}

.elementor-603 .elementor-element.elementor-element-96fe986 .btn-secondary {
  color: #ffffff;
  background-color: #1868dd;
}

.elementor-603 .elementor-element.elementor-element-96fe986 {
  z-index: 2;
}

.elementor-603 .elementor-element.elementor-element-96fe986 > .elementor-widget-container {
  box-shadow: 0px -10px 25px 0px rgba(0, 0, 0, 0.04);
}

.elementor-603 .elementor-element.elementor-element-cfd00bf:not(.elementor-motion-effects-element-type-background), .elementor-603 .elementor-element.elementor-element-cfd00bf > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-color: #113072;
}

.elementor-603 .elementor-element.elementor-element-cfd00bf {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
}

.elementor-603 .elementor-element.elementor-element-cfd00bf > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-603 .elementor-element.elementor-element-896f9a6 .elementor-spacer-inner {
  height: 80px;
}

@media (min-width: 768px) {
  .elementor-603 .elementor-element.elementor-element-0e65d40 {
    width: 15%;
  }

  .elementor-603 .elementor-element.elementor-element-c941537 {
    width: 69.332%;
  }

  .elementor-603 .elementor-element.elementor-element-3656231 {
    width: 15%;
  }

  .elementor-603 .elementor-element.elementor-element-af3da0a {
    width: 15%;
  }

  .elementor-603 .elementor-element.elementor-element-166b514 {
    width: 69.332%;
  }

  .elementor-603 .elementor-element.elementor-element-09b5d79 {
    width: 15%;
  }

  .elementor-603 .elementor-element.elementor-element-1cb9e77 {
    width: 20%;
  }

  .elementor-603 .elementor-element.elementor-element-d124210 {
    width: 59.332%;
  }

  .elementor-603 .elementor-element.elementor-element-e7de62f {
    width: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Faq.vue